import { React, useState, useEffect, useRef } from 'react';
import { Navbar, NavbarBrand, NavItem } from 'reactstrap';
import { useLocation, NavLink } from 'react-router-dom';
import { createHttpClient } from '../utilities/httpclient';
import LoginHelp from './modals/LoginHelp';
import { ThemeToggle } from './ThemeToggle';
import { APPLICATION_API_ENDPOINT } from '../utilities/constants';
import '../styles/header.css';

export function Header() {
    let [userKey, setUserKey] = useState(-1);
    let [userName, setUserName] = useState('');

    const location = useLocation();

    const pageTokens = ['selfservice', 'onboarding/vendordetails', 'x12/file'];

    const usingConnectedPage = pageTokens.every(token => !location.pathname.includes(token));

    const usingAuxiliaryPage = pageTokens.some(token => location.pathname.includes(token));

    const cLoginHelpRef = useRef(null);

    const onLoginInfoClick = e => cLoginHelpRef.current.showLoginHelp(e);

    const getUserInfo = async () => {
        const httpclient = createHttpClient();
        await httpclient.post(`${APPLICATION_API_ENDPOINT}/systemaccess/user`).then(response => {
            setUserKey(+(response?.data?.key));
            setUserName(response?.data?.name);
        });
    };

    useEffect(() => {
        if (usingConnectedPage)
            getUserInfo();
    }, []);

    const settingsURL = `/accountsettings/${userKey}`;

    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white box-shadow mb-3" light>
                {
                    usingConnectedPage && (<NavbarBrand href="/main">my<strong>EDI</strong></NavbarBrand>)
                }
                {
                    usingAuxiliaryPage && (<NavbarBrand>my<strong>EDI</strong></NavbarBrand>)
                }
                <ul className="navbar-nav d-flex flex-grow">
                    <NavItem className="leftside">
                        {
                            usingConnectedPage &&
                            <NavLink
                                to="/main"
                                className={(({ isActive }) => isActive ? "activelink" : "")}
                                >Home
                            </NavLink>
                        }
                    </NavItem>
                    <NavItem className="leftside">
                        {
                            usingConnectedPage &&
                            <NavLink
                                to="/communitylookup"
                                className={(({ isActive }) => isActive ? "activelink" : "")}
                                >Certificate Lookup
                            </NavLink>
                        }
                    </NavItem>
                    {
                        true && <NavItem className="leftside">
                            {
                                usingConnectedPage &&
                                <NavLink
                                    to="/x12"
                                    className={(({ isActive }) => isActive ? "activelink" : "")}
                                >X12 Validator
                                </NavLink>
                            }
                        </NavItem>
                    }
                    {
                        true && <NavItem className="leftside">
                            {
                                usingConnectedPage &&
                                <NavLink
                                    to="/onboarding"
                                    className={(({ isActive }) => isActive ? "activelink" : "")}
                                >Onboarding
                                </NavLink>
                            }
                        </NavItem>
                    }
                    <NavItem className="leftside">
                        <NavLink to="#" onClick={onLoginInfoClick}>Help</NavLink>
                    </NavItem>
                    <NavItem className="rightside d-flex align-items-center">
                        {
                            usingConnectedPage &&
                            <div className="white">
                                <NavLink to={settingsURL}>{userName}</NavLink>
                                &nbsp;|&nbsp;
                                <NavLink to="/logout">Logout</NavLink>
                            </div>
                        }
                        {false && <ThemeToggle />}
                    </NavItem>
                </ul>
            </Navbar>
            <LoginHelp ref={cLoginHelpRef} />
        </header>
    );
}